import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DomainSettingsCard = ({ 
  currentDomain, 
  onDomainUpdate 
}) => {
  const [subdomain, setSubdomain] = useState('my-forms');
  const [customDomain, setCustomDomain] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null);

  const handleVerifyDomain = async () => {
    setIsVerifying(true);
    setTimeout(() => {
      setVerificationStatus('success');
      setIsVerifying(false);
    }, 2000);
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 space-y-6">
      <div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Domain Settings
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Configure subdomain or custom domain for your forms
        </p>
      </div>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">
            Subdomain
          </label>
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="flex-1">
              <Input
                type="text"
                value={subdomain}
                onChange={(e) => setSubdomain(e?.target?.value)}
                placeholder="my-forms"
              />
            </div>
            <div className="flex items-center px-3 py-2 bg-muted rounded-md text-sm text-muted-foreground whitespace-nowrap">
              .webforms.biz
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Your forms will be accessible at: {subdomain}.webforms.biz
          </p>
        </div>

        <div className="pt-4 border-t border-border">
          <label className="text-sm font-medium text-foreground mb-2 block">
            Custom Domain
          </label>
          <div className="space-y-3">
            <Input
              type="text"
              value={customDomain}
              onChange={(e) => setCustomDomain(e?.target?.value)}
              placeholder="forms.yourdomain.com"
              description="Enter your custom domain name"
            />
            
            {customDomain && (
              <div className="space-y-3">
                <div className="p-3 bg-muted rounded-md">
                  <p className="text-xs font-medium text-foreground mb-2">
                    DNS Configuration Required:
                  </p>
                  <div className="space-y-1 text-xs font-mono">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1">
                      <span className="text-muted-foreground">Type:</span>
                      <span className="text-foreground">CNAME</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1">
                      <span className="text-muted-foreground">Name:</span>
                      <span className="text-foreground break-all">{customDomain}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1">
                      <span className="text-muted-foreground">Value:</span>
                      <span className="text-foreground">cname.webforms.biz</span>
                    </div>
                  </div>
                </div>

                <Button
                  variant="outline"
                  size="default"
                  iconName="RefreshCw"
                  iconPosition="left"
                  loading={isVerifying}
                  onClick={handleVerifyDomain}
                  fullWidth
                >
                  Verify DNS Configuration
                </Button>

                {verificationStatus === 'success' && (
                  <div className="flex items-center gap-2 p-3 bg-success/10 text-success rounded-md">
                    <Icon name="CheckCircle2" size={18} />
                    <span className="text-sm font-medium">
                      Domain verified successfully!
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="pt-4 border-t border-border">
        <div className="flex items-start gap-3 p-3 bg-primary/10 rounded-md">
          <Icon name="Shield" size={20} color="var(--color-primary)" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-primary">
              SSL Certificate
            </p>
            <p className="text-xs text-primary/80 mt-1">
              Free SSL certificate automatically provisioned for all domains
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainSettingsCard;